import {dataset, dispatch, listen} from 'nuffjs';
import {TextField} from './text-field';

const ENTER_KEYCODE = 13;

const conf = Object.assign({}, TextField.conf, {
	doSearchAttr: 'doSearch',
});

class SearchField extends TextField {
	static conf = conf;

	static defaultOpts = Object.assign({}, TextField.defaultOpts, {
		searchOnType: true,
		waitTime: 400, // ms
	});

	handleEvents = {
		focus: {type: 'focusin'},
		blur: {type: 'focusout'},
	};

	waitTimeout = null;

	setupEvents() {
		super.setupEvents();
		listen(this, 'click', this.onSearchClick.bind(this), {
			selector: dataset.selector(conf.doSearchAttr),
		});
		listen(this, 'input', this.onInput.bind(this));
	}

	onSearchClick(event) {
		this.dispatchChange(event);
	}

	onInput(event) {
		if (event.which === ENTER_KEYCODE) {
			this.dispatchChange(event);
			super.onChange(event);
		} else if (this.opts.searchOnType) {
			if (this.waitTimeout) {
				clearTimeout(this.waitTimeout);
			}
			this.waitTimeout = setTimeout(() => this.dispatchChange(event), this.opts.waitTime);
		}
	}

	dispatchChange(event) {
		dispatch(this, conf.eventPrefix + 'change', {
			bubbles: true,
			originalEvent: event,
		});
	}

	getInput() {
		return this.querySelector('input[type="text"], input[type="search"]');
	}
}

export {SearchField};
